import { Wrench, ShieldCheck, LifeBuoy, Home } from 'lucide-react';
import OvenMicrowareImg from '../../img/Oven-Microware-service.png'
import CTA from '../Cta';

function OvenMicrowaveRepairService() {
    return (
        <div className="chimney-repair-container">
            {/* Hero Section - No content, just introductory information */}
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Expert Built-in Oven & Microwave Repair Services</h1>
                    <p className="chimney-repair-subtitle">
                        Our expert built-in oven and microwave repair services are designed to restore the performance of your appliances, ensuring they operate safely and efficiently. Whether it’s a minor issue or a major repair, we are here to help maintain the safety of your kitchen. Oven and microwave issues, if left unchecked, can lead to unsafe cooking conditions, electrical hazards, or even fire risks.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Trust our certified technicians to provide a reliable and affordable repair service for your oven and microwave. We offer a comprehensive range of services including inspection, repair, and maintenance, guaranteeing the optimal functioning of your appliances.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Regular maintenance and timely repairs can significantly extend the life of your built-in oven and microwave, preventing costly damage. We handle a variety of repairs, from heating element replacements to electronic control issues, and ensure your kitchen appliances are always in top condition.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Don’t wait for a malfunction to disrupt your daily cooking routine. Our expert repair services will address issues before they become major concerns, keeping your kitchen running smoothly and efficiently.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:18002032499")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={OvenMicrowareImg} alt="" />
            </div>

            {/* Section 1: Why Choose Us */}
            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Oven & Microwave Repair Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Wrench size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Skilled Technicians</h3>
                            <p className="chimney-repair-description">
                                Our technicians are experts trained in the latest oven and microwave repair techniques.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Safety First</h3>
                            <p className="chimney-repair-description">
                                We prioritize safety—ensuring your oven and microwave repairs adhere to all safety standards.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <LifeBuoy size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Emergency Repairs</h3>
                            <p className="chimney-repair-description">
                                Available 24/7 to fix any urgent oven or microwave issues and restore your kitchen’s convenience.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Affordable Solutions</h3>
                            <p className="chimney-repair-description">
                                We offer cost-effective repair options without compromising on quality or reliability.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Our Process */}
            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Oven & Microwave Repair Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Inspection</h3>
                        <p className="chimney-repair-step-description">
                            Our team conducts a thorough inspection to diagnose the issue with your oven or microwave and recommend the best repair solution.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Repair Plan</h3>
                        <p className="chimney-repair-step-description">
                            We provide you with a clear repair plan and cost estimate, ensuring transparency and no hidden charges.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Efficient Repair</h3>
                        <p className="chimney-repair-step-description">
                            Our skilled technicians efficiently repair your oven or microwave with minimal disruption to your daily routine.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Final Check</h3>
                        <p className="chimney-repair-step-description">
                            We conduct a final check to ensure that your appliance is working safely and efficiently before we leave.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default OvenMicrowaveRepairService;
